
import { format, parseISO, isValid } from 'date-fns';
import { tr } from "date-fns/locale";
import Cookies from 'js-cookie';
import { normalizePhoneNumberValue } from '~/utils/phoneNumber';
import { cleanMetaText } from '~/utils/htmlEntities';

export function useCommon() {
  
    const { locale } = useI18n();
    const router = useRouter();

    const isMobileCheck = ()=>{ 
    
    	  var check = false;
        (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
        // console.log("isMobileCheck",check)
        return check;
        
    };
  
    const isJsonString = (str) => {
        if (str) {
            try {
                JSON.parse(str);
            } catch (e) {
                return false;
            }
            return true;
        } else {
            return false
        }
    }; 
    
    function formatMoney(amount) {
      if(amount){   
        return (amount*1).toLocaleString('tr-TR');
      }
    }

  const formatDate = (dateInput, formatValue = 'yyyy-MM-dd') => {
    if (!dateInput) return ''

    let d
    if (typeof dateInput === 'number') {
      // 10 haneli saniye ise ms'e çevir
      const ms = dateInput > 1e12 ? dateInput : dateInput * 1000
      d = new Date(ms)
    } else if (dateInput instanceof Date) {
      d = dateInput
    } else if (typeof dateInput === 'string') {
      const t = dateInput.trim()
      if (!t || t === '0000-00-00' || t.startsWith('0000-00-00')) return ''
      // "YYYY-MM-DD HH:mm:ss" -> "YYYY-MM-DDTHH:mm:ss"
      const normalized = t.includes(' ') ? t.replace(' ', 'T') : t
      d = parseISO(normalized)
      if (!isValid(d)) d = new Date(t)
    } else {
      return ''
    }

    if (!isValid(d)) return ''

    try {
      return locale.value === 'tr'
        ? format(d, formatValue, { locale: tr })
        : format(d, formatValue)
    } catch {
      return ''
    }
  }


    const linkInLanguage = {
      '/tour/umre-turlari':'/tour/umrah-tours',
      '/tour/agustos-umre-turlari':'/tour/agust-umrah-tours',
      '/tour/eylul-umre-turlari':'/tour/september-umrah-tours',
      '/tour/ekim-umre-turlari':'/tour/october-umrah-tours',
      '/tour/kasim-umre-turlari':'/tour/november-umrah-tours',
      '/tour/aralik-umre-turlari':'/tour/december-umrah-tours',
      '/tour/ocak-umre-turlari':'/tour/january-umrah-tours',
      '/tour/subat-umre-turlari':'/tour/february-umrah-tours',
      '/tour/mart-umre-turlari':'/tour/march-umrah-tours',
      '/tour/nisan-umre-turlari':'/tour/april-umrah-tours',
      '/tour/mayis-umre-turlari':'/tour/may-umrah-tours',
      '/tour/haziran-umre-turlari':'/tour/june-umrah-tours',
      '/tour/temmuz-umre-turlari':'/tour/july-umrah-tours',
      '/tour/3-gunluk-umre-turlari':'/tour/3-days-umrah-tours',
      '/tour/5-gunluk-umre-turlari':'/tour/5-days-umrah-tours',
      '/tour/7-gunluk-umre-turlari':'/tour/7-days-umrah-tours',
      '/tour/8-gunluk-umre-turlari':'/tour/8-days-umrah-tours',
      '/tour/10-gunluk-umre-turlari':'/tour/10-days-umrah-tours',
      '/tour/12-gunluk-umre-turlari':'/tour/12-days-umrah-tours',
      '/tour/13-gunluk-umre-turlari':'/tour/13-days-umrah-tours',
      '/tour/ramazan-umre-turlari':'/tour/ramadan-umrah-tours',
      '/tour/somestr-umre-turlari':'/tour/somestr-umre-turlari',
      '/tour/15-gunluk-umre-turlari':'/tour/15-days-umrah-tours', 
      '/tour/kisiye-ozel-umre-turlari':'/tour/private-umrah-tours',
      '/page/banka-hesaplari':'/page/bank-accounts',
      '/tour/5-yildizli-luks-umre-turlari':'/tour/5-star-luxury-umrah-packages',
      '/tour/vip-umre-programlari':'/tour/vip-luxury-umrah-packages',
      '/tour/unlu-hocalarla-umre-turlari':'/tour/popular-guides-umrah-packages',
      '/page/umre-rehberi': '/page/umrah-guide',
      '/page/hac': '/page/hajj',
      '/page/umre-tur-fotograflari': '/page/umrah-tour-photos',
      '/page/belgeler': '/page/documents',
      '/page/yorumlar': '/page/comments',
      '/page/ekibimiz': '/page/our-team',
      '/page/umre-hizmet-standartlari': '/page/umrah-service-standards',
      '/page/hakkimizda': '/page/aboutus',
      '/page/umreye-gitmeden-alinacaklar-rehberi': '/page/what-should-you-pack-for-umrah',
      '/page/umre-fiyatlari-nasil-hesaplanir':'/page/what-determines-umrah-prices',
      '/page/grup-bayi-ozel-umre':'/page/umrah-for-dealers-and-private-groups',
      '/page/umre-nedir':'/page/what-is-umrah',
      '/page/umre_nedir':'/page/umre-icin-gerekli-belgeler',
      '/page/umreye-gitme-sartlari-nelerdir':'/page/what-are-the-obligations-of-going-to-umrah',
      '/page/umre-turlari-nezaman-yapilir':'/page/umrah-tours-are-held-when',
      '/page/umre-hakkinda-bilinmesi-gerekenler':'/page/what-to-know-about-umrah',
      '/page/umre-ve-farzlari': '/page/what-is-umrah-and-its-obligations',
      '/page/umre-ve-hac-rehberi': '/page/umrah-and-hajj-guide',
      '/page/umre-rehberi': '/page/umrah-guide',
      '/page/yolculuk-merkezi': '/page/journey-centre',
      "/page/inanc-tur-umre-farki" : "/page/inanc-travel-your-spiritual-journey-with",
    }

    const getPath = (url) => {
      if(url.includes("http")){
          return url;
      }else 
      if(locale.value=="tr"){
        return (`${url}`)
      }else{
        if(linkInLanguage[url]){
          return (`/${locale.value}${linkInLanguage[url]}`)
        }else{
          return (`/${locale.value}${url}`)
        }
      }
  };

    const goPath = (url) => {

      // console.log("url",url)
        if(url.includes("http")){
            window.open(url,"_self");
        }else 
        if(locale.value=="tr"){
          router.push(`${url}`) 
        }else{
            
            if(linkInLanguage[url]){
              router.push(`/${locale.value}${linkInLanguage[url]}`)
            }else{
              router.push(`/${locale.value}${url}`)
            }
        }
    };

    const goPathBlank = (url) => {
      if(url.includes("http")){
          window.open(url, '_blank');
      }else
      if(locale.value=="en"){ 
          window.open(url, '_blank');
      }else{ 
          window.open(`/${locale.value}${url}`, '_blank');
      }
     
  };

    const     HtmlEncode = (s)=>
    {
      // var el = document.createElement("div");
	    //console.log("s",s);
      if(s &&  s!='' && s!=null && typeof s == 'string'){
          s = s.replaceAll("&lt;", "<");
          s = s.replaceAll("&gt;", ">");
          s = s.replaceAll("&quot;", "\"");
          s = s.replaceAll("&#039;", "'");
      }
      return s;
    };

    const addToHistory = (part,data)=>{
       //  console.log("1-->")
        if(process.client ){

            let history =  window.localStorage.getItem(part);
            if(!history){
              localStorage.setItem(part,JSON.stringify([]))
            }
            let list = []
            if(history && history.charAt(0)=="["){
                list = JSON.parse(history);
            } 
            if(part && (!list || (list && list?.find(k=> k.word==data.word)))){
              // console.log("Visited before")
            }else{
             // console.log("Adding to:"+part)
                  if(part=="word"){
                    list.push({
                      ...data,
                      date:Date.now()
                    })
                    localStorage.setItem(part, JSON.stringify(list));
                   
                  }

            } 
        }
    };
    const showTime = (time) => {

      let d = time/ 60;
      let m = Math.floor(d);
      let s = time - m * 60;
      m = m < 10 ? '0' + m : m;
      s = s < 10 ? '0' + s : s;
     
      return m + ':' + s;

    };
 
    const showImage = (i, w, h, c, q, sa, nup) => {
      if(i){
          let imp = i.split(".");
          let total_point = imp.length-1;
          let ext = imp[total_point];

          if(ext=="svg"){
           
            if(i.charAt(0)=="/"){
             
              return  "https://image.inanctur.com.tr" + i
             }else if(i.charAt(0)=="v"){
              return  "https://image.inanctur.com.tr" + i
             }
            return i;

          }else{
                delete imp[total_point];
                let im = imp.join(".").slice(0, -1);


                let imaj = im;
               
                w > 0 ? imaj += '_w_' + w + 'px' : '';
                h > 0 ? imaj += '_h_' + h + 'px' : '';
                // c != "" ? imaj += '_c_crop' : '';
                q > 0 ? imaj += '_q_' + q : '';
                sa == "jpeg" || sa == "jpg" || sa == "png" || sa == "gif"  ? imaj += '_wisa_' + sa : '';
                nup == "no-upscale" ? imaj += '_' + nup : '';
                imaj +=  '.' + ext; 
                if(imaj.startsWith('https://image.inanctur.com.tr/yonetim/images/turlar/auto/')){ 
                  return imaj;
                }else{
                  imaj = imaj.replace('http://inancturizm.gen.tr/','https://image.inanctur.com.tr/');
                  imaj = imaj.replace('inanctur.org/','image.inanctur.com.tr/');
                  imaj = imaj.replace('yonetim.inanctur.com.tr/','image.inanctur.com.tr/');
                  imaj = imaj.replace('yonetim.inanctur.com/','image.inanctur.com.tr/');
              
                  imaj = imaj.replace("http://","https://")
                  imaj = imaj.replace("/visual/","/")
                  imaj = imaj.replace("/visual2/","/")
                  imaj = imaj.replace(".com.tr/yonetim/",".com.tr/yonetim/")
                  imaj = imaj.replace("inanctur.kolaysite.co/","image.inanctur.com.tr/")
                  imaj = imaj.replace("//inanctur.com.tr/","//image.inanctur.com.tr/")
                  imaj = imaj.replace("../../yonetim/","https://image.inanctur.com.tr/yonetim/")
                }
               
             
                if(imaj.startsWith("/images")){
                  imaj = "/yonetim"+imaj
                }else  if(i.startsWith("images")){
                  imaj = "/yonetim/"+imaj
                }

                // if(sa=="webp"){
                //   imaj = imaj.replace(".jpg",".webp");
                //   imaj = imaj.replace(".png",".webp");
                //   imaj = imaj.replace(".gif",".webp");
                // }  

                if(imaj.charAt(0)=="/"){
                   return "https://image.inanctur.com.tr" + imaj
                }else if(imaj.slice(0,7)=="images/"){
                  return "https://image.inanctur.com.tr/" + imaj
                }else if(i.charAt(0)=="v"){
                  return  "https://image.inanctur.com.tr" + imaj
                 }

                return imaj;
            }
      }
    };


    const replaceWord = (word, limit = 120)=> {
        // let a = word.replace(/<[^>]*>/g, '');
        // a=a.replace('</br>', '');
        // return a.substring(0, 100)
        // return htmlToText(word, {
        //     wordwrap: 130
        // });
        if(word && typeof word == "string"){
            word = HtmlEncode(word);
            let name = word.split(">");
            let arr = [];
          //   console.log("name", name);
            name.forEach(element => {
              let splitted = element.split("<");
          if(splitted && splitted[0]){
            arr.push(splitted[0].trim());
          }
            });
          //   console.log("arr", arr);
  
            let text = arr.join(" ").substring(0, limit);
          //   console.log("text", text);
  
            if (text.length > 100) {
              return text
                .split(" ")
                .slice(0, -1)
                .join(" ");
            }
            return text;
        }
      };


      const setHeadMeta = ()=>{
          const pageData = usePageData();

          useHead({
            htmlAttrs: {
              lang: locale.value || 'tr'
            }, 
          })

          let pageText = locale.value=="tr" ? ' konusu hakkında yazımız buy sayfada bulabilirsiniz. ' : ' : you can find our article on this topic on this page.'; ;
          let desc = cleanMetaText(pageData.value?.wa_description?.replace("[firm]","InancTur.com.tr").replace("[title]","Inanctur.com.tr").replace("[page]", pageText))
          if(pageData.value.wa_title){
                const title = cleanMetaText(pageData.value?.wa_title?.replace("Inanç Turizm",pageData.value?.SA_Baslik)) || "Inanctur.com.tr"
                const ogTitle = cleanMetaText(pageData.value?.SA_Baslik) || "Inanctur.com.tr"
                 
                    useSeoMeta({
                                  title,
                                  ogTitle,
                                  description: desc || "Inanctur.com.tr",
                                  ogSiteName : "Inanc Turizm",
                                  ogDescription: desc || "Inanctur.com.tr", 
                                  ogType: "website",
                                  ogImage: pageData.value?.SA_Fotograf ||  "https://inanctur.com.tr/assets/img/logo/logo.png",
                                
                    })

                    /*script: [
                      {
                          type: 'application/ld-json',
                          children: JSON.stringify(jsonLd),
                      },
                  ],*/
           }
      }


      
     const  decodeHTMLEntities = (text,data)=>{
      var entities = {
        'amp': '&',
        'apos': '\'',
        'lt': '<',
        'gt': '>',
        'quot': '"',
        'nbsp': '\xa0',
        '&Ouml;': 'Ö',
        '&cc': 'g',
      };
      var entityPattern = /&([a-z]+);/ig;
       
        if(text && typeof text == "string"){
            // A single replace pass with a static RegExp is faster than a loop
            return text.replace(entityPattern, function(match, entity) {
              entity = entity.toLowerCase();
              if (entities.hasOwnProperty(entity)) {
                return entities[entity];
              }
              // return original string if there is no matching entity (no replace)
              return match;
            });
        }
      return text;
    }

    const addScript = (url)=>{
      var script = document.createElement('script');
      script.type = 'application/javascript';
      script.src = url;
      document.head.appendChild(script);
    }

    const createRecaptcha = ()=>{
      const config = useRuntimeConfig()
      if(typeof grecaptcha=="undefined" || !grecaptcha){
        //  console.log("addd script")
         addScript(`https://www.google.com/recaptcha/api.js?render=${config.public.recaptchaKey}`)
       }
    
       return new Promise((resolve, reject) => {
          if(typeof grecaptcha!="undefined"  && grecaptcha){
            setTimeout(()=>{ 
              grecaptcha.ready(function() {
                grecaptcha.execute(config.public.recaptchaKey, {action: 'submit'}).then(function(token) {
                    // Add your logic to submit to your backend server here.
          
                        resolve(token)
                    });
                    });
              },1000);
          }else{
            resolve('')
          }
        });
    }

    const logout = ()=>{
      Cookies.remove('user', { path: '/' });
      Cookies.remove('token', { path: '/' });
      useUser().value = null;
      useHeader().value = {
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8"
      };
      const config = useRuntimeConfig()
      window.open(`${config.public.apiBase}/auth/logout`,"_self");
    }

    const normalizePhoneNumber = (phone) => normalizePhoneNumberValue(phone)




const turkishToEnglishAndFormatForUrl = (text)=>{
  const turkishChars = {
    'ç': 'c',
    'ğ': 'g',
    'ı': 'i',
    'ö': 'o',
    'ş': 's',
    'ü': 'u',
    'Ç': 'C',
    'Ğ': 'G',
    'İ': 'I',
    'Ö': 'O',
    'Ş': 'S',
    'Ü': 'U'
  };

  // Replace Turkish characters with English equivalents
  let formattedText = text.replace(/[çğışöüÇĞİŞÖÜ]/g, char => turkishChars[char] || char);

  // Convert to lowercase
  formattedText = formattedText.toLowerCase();

  // Replace spaces and non-alphanumeric characters with hyphens
  formattedText = formattedText.replace(/[^a-z0-9]+/g, '-');

  // Remove leading/trailing hyphens
  formattedText = formattedText.replace(/^-+|-+$/g, '');

  return formattedText;
}



const getUserInfo = ()=>{
  return {
      userAgent: navigator.userAgent, // Kullanıcının tarayıcı bilgisi
      platform: navigator.platform, // İşletim sistemi
      language: navigator.language, // Tarayıcı dili
      screenWidth: screen.width, // Ekran genişliği
      screenHeight: screen.height, // Ekran yüksekliği
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone, // Zaman dilimi
  };
}


const copyText = (nText) => {

  const body = document.querySelector('body');
  const area = document.createElement('textarea');
  
    body.appendChild(area);
    let text = nText;
      text = text.replaceAll("<br />","\n");
      text = text.replaceAll("<strong>","*");
      text = text.replaceAll("</strong>","*");
      text = text.replaceAll("<b>","*");
      text = text.replaceAll("</b>","*");
    area.value = text
    area.select();
    document.execCommand('copy'); 
    body.removeChild(area); 
  
  };



const getIsMobile = ()=>{
 
  if (process.server) {
    const headers = useRequestHeaders(['user-agent']) 
    const ua = headers['user-agent'] || '' 
    // console.log("mobile server: ",/mobile/i.test(ua));
    return /mobile/i.test(ua)
  } 
  // Client-side fallback (isteğe bağlı)
  if (process.client) {  
    return window.matchMedia('(max-width: 768px)').matches // matchMedia: layout reflow tetiklemez
  }
    // Varsayılan değer
  return false
}

const startCall = async (mobile)=>{
  const config = useRuntimeConfig();
  const response = await fetch(`${config.public.apiBase}/verimor/originate`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...(useHeader()?.value || {})
    },
    body: JSON.stringify({ phone: mobile })
  });
  const data = await response.json();
  if (!response.ok || data?.success !== true) {
    throw new Error(data?.message || 'Şirket hattından arama başlatılamadı.');
  }
  return data;
}

    
    return {
        isMobileCheck, 
        replaceWord,
        isJsonString,
        goPath,
        getPath,
        goPathBlank,
        formatDate,
        formatMoney,
        addToHistory,
        HtmlEncode,
        showImage, 
        showTime, 
        decodeHTMLEntities,
        setHeadMeta,
        linkInLanguage,
        addScript,
        createRecaptcha,
        logout,
        normalizePhoneNumber,
        turkishToEnglishAndFormatForUrl,
        getUserInfo,
        copyText,
        getIsMobile,
        startCall
    };
}
